// src/components/common/Seo.js — 페이지별 검색·공유 메타 (title, description, canonical, robots, OG, JSON-LD)
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://gateon.kr';
export const SITE_NAME = '게이트온 GATEON';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/img/og/gateon-og.png`;

// JSON-LD 를 <script> 안에 넣을 때 </script> 탈출 차단
const ld = (obj) => JSON.stringify(obj).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');

export const breadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

/**
 * @param {string} title       <title> 전체 문자열 (브랜드 포함)
 * @param {string} description 120~150자 권장
 * @param {string} path        canonical 경로 ('/faq'). 쿼리 없이.
 * @param {boolean} noindex    유틸리티·개인 페이지
 * @param {object|object[]} jsonLd 구조화 데이터
 */
const Seo = ({ title, description, path, noindex = false, image = DEFAULT_OG_IMAGE, type = 'website', jsonLd }) => {
  const url = path != null ? `${SITE_URL}${path}` : null;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? 'noindex,follow' : 'index,follow,max-image-preview:large'} />
      {url && !noindex && <link rel="canonical" href={url} />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:image" content={image} />
      {image === DEFAULT_OG_IMAGE && <meta property="og:image:width" content="1200" />}
      {image === DEFAULT_OG_IMAGE && <meta property="og:image:height" content="630" />}
      <meta property="og:image:alt" content={image === DEFAULT_OG_IMAGE ? '게이트온 — 티켓 판매부터 입장까지 게이트온 하나로' : title} />
      <meta property="og:locale" content="ko_KR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{ld(b)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
